import styled from 'styled-components'

export const Description = styled.div`
  margin-bottom: 16px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`
